// =============================================================
// 💖 SatisfactionChart.jsx — Satisfação dos usuários
// =============================================================

import React from "react";
import {
  ResponsiveContainer,
  AreaChart,
  Area,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
} from "recharts";

export default function SatisfactionChart({ data = [] }) {
  if (!data || data.length === 0) {
    return <div className="ia-chart-empty">Nenhuma avaliação ainda.</div>;
  }

  return (
    <div className="ia-chart-wrapper">
      <ResponsiveContainer width="100%" height={240}>
        <AreaChart data={data}>
          <CartesianGrid strokeDasharray="3 3" stroke="#f3c5d8" />
          <XAxis dataKey="date" tick={{ fontSize: 11, fill: "#b22857" }} />
          <YAxis domain={[0, 5]} tick={{ fontSize: 11, fill: "#b22857" }} />
          <Tooltip />

          <Area
            type="monotone"
            dataKey="rating"
            stroke="#f06292"
            fill="#f8c6d9"
            strokeWidth={2}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
